webpackJsonp([104101334113578],{

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(145);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VerticalTimeline = function (_Component) {
	  _inherits(VerticalTimeline, _Component);
	
	  function VerticalTimeline() {
	    _classCallCheck(this, VerticalTimeline);
	
	    return _possibleConstructorReturn(this, (VerticalTimeline.__proto__ || Object.getPrototypeOf(VerticalTimeline)).apply(this, arguments));
	  }
	
	  _createClass(VerticalTimeline, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animate = _props.animate,
	          children = _props.children;
	      var className = this.props.className;
	
	
	      className += ' vertical-timeline';
	
	      if (animate) {
	        className += ' vertical-timeline--animate';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className.trim() },
	        children
	      );
	    }
	  }]);
	
	  return VerticalTimeline;
	}(_react.Component);
	
	VerticalTimeline.propTypes =  false ? {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
	  className: _propTypes2.default.string,
	  animate: _propTypes2.default.bool
	} : {};
	
	VerticalTimeline.defaultProps = {
	  animate: true,
	  className: ''
	};
	
	exports.default = VerticalTimeline;

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactVisibilitySensor = __webpack_require__(459);
	
	var _reactVisibilitySensor2 = _interopRequireDefault(_reactVisibilitySensor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VerticalTimelineElement = function (_Component) {
	  _inherits(VerticalTimelineElement, _Component);
	
	  function VerticalTimelineElement(props) {
	    _classCallCheck(this, VerticalTimelineElement);
	
	    var _this = _possibleConstructorReturn(this, (VerticalTimelineElement.__proto__ || Object.getPrototypeOf(VerticalTimelineElement)).call(this, props));
	
	    _this.onVisibilitySensorChange = _this.onVisibilitySensorChange.bind(_this);
	    _this.state = { visible: false };
	    return _this;
	  }
	
	  _createClass(VerticalTimelineElement, [{
	    key: 'onVisibilitySensorChange',
	    value: function onVisibilitySensorChange(isVisible) {
	      if (isVisible) {
	        this.setState({ visible: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          children = _props.children,
	          icon = _props.icon,
	          iconStyle = _props.iconStyle,
	          date = _props.date,
	          position = _props.position;
	      var className = this.props.className;
	
	
	      className += ' vertical-timeline-element';
	
	      if (position === 'left') {
	        className += ' vertical-timeline-element--left';
	      }
	
	      if (position === 'right') {
	        className += ' vertical-timeline-element--right';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { id: id, className: className },
	        _react2.default.createElement(
	          _reactVisibilitySensor2.default,
	          { onChange: this.onVisibilitySensorChange },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { style: iconStyle, className: 'vertical-timeline-element-icon ' + (this.state.visible ? 'bounce-in' : 'is-hidden') },
	              icon
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'vertical-timeline-element-content ' + (this.state.visible ? 'bounce-in' : 'is-hidden') },
	              children,
	              _react2.default.createElement(
	                'span',
	                { className: 'vertical-timeline-element-date' },
	                date
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return VerticalTimelineElement;
	}(_react.Component);
	
	VerticalTimelineElement.propTypes =  false ? {
	  id: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
	  className: _propTypes2.default.string,
	  icon: _propTypes2.default.element,
	  iconStyle: _propTypes2.default.shape({}),
	  date: _propTypes2.default.string,
	  position: _propTypes2.default.string
	} : {};
	
	VerticalTimelineElement.defaultProps = {
	  id: '',
	  children: '',
	  className: '',
	  icon: null,
	  iconStyle: null,
	  date: '',
	  position: ''
	};
	
	exports.default = VerticalTimelineElement;

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// this should be the entry point to your library
	module.exports = {
	  VerticalTimeline: __webpack_require__(455).default,
	  VerticalTimelineElement: __webpack_require__(456).default
	};

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

	// Tell whether the rect is visible, given an offset
	//
	// return: boolean
	module.exports = function (offset, rect, containmentRect) {
	  var offsetDir = offset.direction;
	  var offsetVal = offset.value;
	
	  // Rules for checking different kind of offsets. In example if the element is
	  // 90px below viewport and offsetTop is 100, it is considered visible.
	  switch (offsetDir) {
	  case 'top':
	    return ((containmentRect.top + offsetVal) < rect.top) &&
	      (containmentRect.bottom > rect.bottom) &&
	      (containmentRect.left < rect.left) &&
	      (containmentRect.right > rect.right);
	
	  case 'left':
	    return ((containmentRect.left + offsetVal) < rect.left) &&
	      (containmentRect.bottom > rect.bottom) &&
	      (containmentRect.top < rect.top) &&
	      (containmentRect.right > rect.right);
	
	  case 'bottom':
	    return ((containmentRect.bottom - offsetVal) > rect.bottom) &&
	      (containmentRect.left < rect.left) &&
	      (containmentRect.right > rect.right) &&
	      (containmentRect.top < rect.top);
	
	  case 'right':
	    return ((containmentRect.right - offsetVal) > rect.right) &&
	      (containmentRect.left < rect.left) &&
	      (containmentRect.top < rect.top) &&
	      (containmentRect.bottom > rect.bottom);
	  }
	}


/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(102);
	var PropTypes = __webpack_require__(8);
	var createReactClass = __webpack_require__(283);
	var isVisibleWithOffset = __webpack_require__(458)
	
	var containmentPropType = PropTypes.any;
	
	if (typeof window !== 'undefined') {
	  containmentPropType = PropTypes.instanceOf(window.Element);
	}
	
	function throttle (callback, limit) {
	    var wait = false;
	    return function () {
	        if (!wait) {
	            wait = true;
	            setTimeout(function () {
	                callback();
	                wait = false;
	            }, limit);
	        }
	    }
	}
	
	function debounce(func, wait) {
	  var timeout;
	  return function() {
	    var context = this, args = arguments;
	    var later = function() {
	      timeout = null;
	      func.apply(context, args);
	    };
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	  };
	}
	
	module.exports = createReactClass({
	  displayName: 'VisibilitySensor',
	
	  propTypes: {
	    onChange: PropTypes.func,
	    active: PropTypes.bool,
	    partialVisibility: PropTypes.oneOfType([
	      PropTypes.bool,
	      PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	    ]),
	    delayedCall: PropTypes.bool,
	    offset: PropTypes.oneOfType([
	      PropTypes.shape({
	        top: PropTypes.number,
	        left: PropTypes.number,
	        bottom: PropTypes.number,
	        right: PropTypes.number
	      }),
	      // deprecated offset property
	      PropTypes.shape({
	        direction: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	        value: PropTypes.number
	      })
	    ]),
	    scrollCheck: PropTypes.bool,
	    scrollDelay: PropTypes.number,
	    scrollThrottle: PropTypes.number,
	    resizeCheck: PropTypes.bool,
	    resizeDelay: PropTypes.number,
	    resizeThrottle: PropTypes.number,
	    intervalCheck: PropTypes.bool,
	    intervalDelay: PropTypes.number,
	    containment: containmentPropType,
	    children: PropTypes.oneOfType([
	      PropTypes.element,
	      PropTypes.func,
	    ]),
	    minTopValue: PropTypes.number,
	  },
	
	  getDefaultProps: function () {
	    return {
	      active: true,
	      partialVisibility: false,
	      minTopValue: 0,
	      scrollCheck: false,
	      scrollDelay: 250,
	      scrollThrottle: -1,
	      resizeCheck: false,
	      resizeDelay: 250,
	      resizeThrottle: -1,
	      intervalCheck: true,
	      intervalDelay: 100,
	      delayedCall: false,
	      offset: {},
	      containment: null,
	      children: React.createElement('span')
	    };
	  },
	
	  getInitialState: function () {
	    return {
	      isVisible: null,
	      visibilityRect: {}
	    };
	  },
	
	  componentDidMount: function () {
	    this.node = ReactDOM.findDOMNode(this);
	    if (this.props.active) {
	      this.startWatching();
	    }
	  },
	
	  componentWillUnmount: function () {
	    this.stopWatching();
	  },
	
	  componentWillReceiveProps: function (nextProps) {
	    if (nextProps.active && !this.props.active) {
	      this.setState(this.getInitialState());
	      this.startWatching();
	    } else if (!nextProps.active) {
	      this.stopWatching();
	    }
	  },
	
	  getContainer: function () {
	    return this.props.containment || window;
	  },
	
	  addEventListener: function (target, event, delay, throttle) {
	    if (!this.debounceCheck) {
	      this.debounceCheck = {};
	    }
	
	    var timeout;
	    var func;
	
	    var later = function () {
	      timeout = null;
	      this.check();
	    }.bind(this);
	
	    if (throttle > -1) {
	      func = function () {
	        if (!timeout) {
	          timeout = setTimeout(later, throttle || 0);
	        }
	      };
	    } else {
	      func = function () {
	        clearTimeout(timeout);
	        timeout = setTimeout(later, delay || 0);
	      };
	    }
	
	    var info = {
	      target: target,
	      fn: func,
	      getLastTimeout: function () {
	        return timeout;
	      },
	    };
	
	    target.addEventListener(event, info.fn);
	    this.debounceCheck[event] = info;
	  },
	
	  startWatching: function () {
	    if (this.debounceCheck || this.interval) { return; }
	
	    if (this.props.intervalCheck) {
	      this.interval = setInterval(this.check, this.props.intervalDelay);
	    }
	
	    if (this.props.scrollCheck) {
	      this.addEventListener(
	        this.getContainer(),
	        'scroll',
	        this.props.scrollDelay,
	        this.props.scrollThrottle
	      );
	    }
	
	    if (this.props.resizeCheck) {
	      this.addEventListener(
	        window,
	        'resize',
	        this.props.resizeDelay,
	        this.props.resizeThrottle
	      );
	    }
	
	    // if dont need delayed call, check on load ( before the first interval fires )
	    !this.props.delayedCall && this.check();
	  },
	
	  stopWatching: function () {
	    if (this.debounceCheck) {
	      // clean up event listeners and their debounce callers
	      for (var debounceEvent in this.debounceCheck) {
	        if (this.debounceCheck.hasOwnProperty(debounceEvent)) {
	          var debounceInfo = this.debounceCheck[debounceEvent];
	
	          clearTimeout(debounceInfo.getLastTimeout());
	          debounceInfo.target.removeEventListener(
	            debounceEvent, debounceInfo.fn
	          );
	
	          this.debounceCheck[debounceEvent] = null;
	        }
	      }
	    }
	    this.debounceCheck = null;
	
	    if (this.interval) { this.interval = clearInterval(this.interval); }
	  },
	
	  /**
	   * Check if the element is within the visible viewport
	   */
	  check: function () {
	    var el = this.node;
	    var rect;
	    var containmentRect;
	    // if the component has rendered to null, dont update visibility
	    if (!el) {
	      return this.state;
	    }
	
	    rect = el.getBoundingClientRect();
	
	    if (this.props.containment) {
	      var containmentDOMRect = this.props.containment.getBoundingClientRect();
	      containmentRect = {
	        top: containmentDOMRect.top,
	        left: containmentDOMRect.left,
	        bottom: containmentDOMRect.bottom,
	        right: containmentDOMRect.right,
	      }
	    } else {
	      containmentRect = {
	        top: 0,
	        left: 0,
	        bottom: window.innerHeight || document.documentElement.clientHeight,
	        right: window.innerWidth || document.documentElement.clientWidth
	      };
	    }
	
	    // Check if visibility is wanted via offset?
	    var offset = this.props.offset || {};
	    var hasValidOffset = typeof offset === 'object';
	    if (hasValidOffset) {
	      containmentRect.top += offset.top || 0;
	      containmentRect.left += offset.left || 0;
	      containmentRect.bottom -= offset.bottom || 0;
	      containmentRect.right -= offset.right || 0;
	    }
	
	    var visibilityRect = {
	      top: rect.top >= containmentRect.top,
	      left: rect.left >= containmentRect.left,
	      bottom: rect.bottom <= containmentRect.bottom,
	      right: rect.right <= containmentRect.right
	    };
	
	    var isVisible = (
	      visibilityRect.top &&
	      visibilityRect.left &&
	      visibilityRect.bottom &&
	      visibilityRect.right
	    );
	
	    // check for partial visibility
	    if (this.props.partialVisibility) {
	      var partialVisible =
	          rect.top <= containmentRect.bottom && rect.bottom >= containmentRect.top &&
	          rect.left <= containmentRect.right && rect.right >= containmentRect.left;
	
	      // account for partial visibility on a single edge
	      if (typeof this.props.partialVisibility === 'string') {
	        partialVisible = visibilityRect[this.props.partialVisibility]
	      }
	
	      // if we have minimum top visibility set by props, lets check, if it meets the passed value
	      // so if for instance element is at least 200px in viewport, then show it.
	      isVisible = this.props.minTopValue
	        ? partialVisible && rect.top <= (containmentRect.bottom - this.props.minTopValue)
	        : partialVisible
	    }
	
	    // Deprecated options for calculating offset.
	    if (typeof offset.direction === 'string' &&
	        typeof offset.value === 'number') {
	      console.warn('[notice] offset.direction and offset.value have been deprecated. They still work for now, but will be removed in next major version. Please upgrade to the new syntax: { %s: %d }', offset.direction, offset.value)
	
	      isVisible = isVisibleWithOffset(offset, rect, containmentRect);
	    }
	
	    var state = this.state;
	    // notify the parent when the value changes
	    if (this.state.isVisible !== isVisible) {
	      state = {
	        isVisible: isVisible,
	        visibilityRect: visibilityRect
	      };
	      this.setState(state);
	      if (this.props.onChange) this.props.onChange(isVisible, visibilityRect);
	    }
	
	    return state;
	  },
	
	  render: function () {
	    if (this.props.children instanceof Function) {
	      return this.props.children({
	        isVisible: this.state.isVisible,
	        visibilityRect: this.state.visibilityRect,
	      });
	    }
	    return React.Children.only(this.props.children);
	  }
	});


/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutDetailItemsList = function AboutDetailItemsList(_ref) {
	  var group = _ref.group;
	  return _react2.default.createElement(
	    'ul',
	    null,
	    group.map(function (item) {
	      return _react2.default.createElement(
	        'li',
	        { key: item },
	        item
	      );
	    })
	  );
	};
	
	var AboutDetailItems = function AboutDetailItems(_ref2) {
	  var heading = _ref2.heading,
	      items = _ref2.items;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'strong',
	      null,
	      heading
	    ),
	    _react2.default.createElement(AboutDetailItemsList, { group: items })
	  );
	};
	
	var DegreeDetails = function DegreeDetails(_ref3) {
	  var degree = _ref3.degree;
	  return _react2.default.createElement(
	    'div',
	    { className: 'education-degree' },
	    _react2.default.createElement(
	      'h5',
	      null,
	      _react2.default.createElement('i', { className: 'fa fa-graduation-cap', 'aria-hidden': 'true' }),
	      ' ',
	      degree.degree,
	      ' ',
	      _react2.default.createElement(
	        'small',
	        null,
	        degree.title
	      )
	    ),
	    _react2.default.createElement(
	      'h6',
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: degree.link, target: '_blank' },
	        degree.school
	      )
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      degree.items.map(function (item) {
	        return _react2.default.createElement(
	          'li',
	          { key: item },
	          item
	        );
	      })
	    )
	  );
	};
	
	var EducationDetails = function EducationDetails(_ref4) {
	  var details = _ref4.details;
	  return _react2.default.createElement(
	    'div',
	    null,
	    details.map(function (degree) {
	      return _react2.default.createElement(DegreeDetails, { key: degree.title, degree: degree });
	    })
	  );
	};
	
	var AboutDetails = function AboutDetails(_ref5) {
	  var details = _ref5.details;
	  return _react2.default.createElement(
	    'div',
	    null,
	    details.map(function (item) {
	      return _react2.default.createElement(
	        'ul',
	        { key: item.text, className: 'list-unstyled home-about-list' },
	        _react2.default.createElement(
	          'li',
	          { className: 'media' },
	          _react2.default.createElement('i', { className: 'd-none d-md-block mr-3 align-self-center mr-3 lg ' + item.icon, 'aria-hidden': 'true' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'media-body' },
	            _react2.default.createElement(
	              'h4',
	              { className: 'mt-0 mb-1' },
	              item.text
	            ),
	            item.education && _react2.default.createElement(EducationDetails, { details: item.education }),
	            _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: item.description } }),
	            item.traits && item.traits.length && _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(AboutDetailItems, { heading: 'Personal Traits', items: item.traits })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(AboutDetailItems, { heading: 'Development', items: item.dev })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(AboutDetailItems, { heading: 'Platforms', items: item.platforms })
	              )
	            )
	          )
	        )
	      );
	    })
	  );
	};
	
	exports.default = AboutDetails;
	module.exports = exports['default'];

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ParagraphSection = function ParagraphSection(_ref) {
	  var paragraphs = _ref.paragraphs;
	  return _react2.default.createElement(
	    'div',
	    null,
	    paragraphs.map(function (p) {
	      return _react2.default.createElement(
	        'p',
	        { key: p.heading },
	        _react2.default.createElement(
	          'strong',
	          null,
	          p.heading
	        ),
	        '\xA0',
	        p.text
	      );
	    })
	  );
	};
	
	exports.default = ParagraphSection;
	module.exports = exports['default'];

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Projects = function Projects(_ref) {
	  var projects = _ref.projects,
	      _ref$limit = _ref.limit,
	      limit = _ref$limit === undefined ? 0 : _ref$limit,
	      _ref$type = _ref.type,
	      type = _ref$type === undefined ? 'card-deck' : _ref$type;
	  return _react2.default.createElement(
	    'div',
	    { className: type },
	    projects.slice(0, limit ? limit : projects.length).map(function (item, index) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'card', key: item.node.id },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: item.node.frontmatter.path },
	          _react2.default.createElement('img', { className: 'card-img-top border-bottom', src: item.node.frontmatter.thumbnail, alt: 'Project Thumbnail' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-body' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'card-title' },
	            item.node.frontmatter.title
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'card-text' },
	            item.node.frontmatter.description
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cushy-bottom text-center' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: item.node.frontmatter.path, className: 'btn btn-outline-info' },
	            'View Details'
	          )
	        )
	      );
	    })
	  );
	};
	
	exports.default = Projects;
	module.exports = exports['default'];

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollComponent = function (_Component) {
	  _inherits(ScrollComponent, _Component);
	
	  function ScrollComponent() {
	    _classCallCheck(this, ScrollComponent);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.scrollHandler = _this._handleScroll.bind(_this);
	    return _this;
	  }
	
	  ScrollComponent.prototype._handleScroll = function _handleScroll(event) {
	    var doc = document.documentElement;
	    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
	    this.onScroll(event, top);
	  };
	
	  ScrollComponent.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('scroll', this.scrollHandler);
	  };
	
	  ScrollComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('scroll', this.scrollHandler);
	  };
	
	  ScrollComponent.prototype.onScroll = function onScroll() {
	    // Override here.
	  };
	
	  return ScrollComponent;
	}(_react.Component);
	
	exports.default = ScrollComponent;
	module.exports = exports['default'];

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceDetailItemsList = function ServiceDetailItemsList(_ref) {
	  var group = _ref.group;
	  return _react2.default.createElement(
	    'ul',
	    null,
	    group.map(function (item) {
	      return _react2.default.createElement(
	        'li',
	        { key: item },
	        item
	      );
	    })
	  );
	};
	
	var ServiceDetailItems = function ServiceDetailItems(_ref2) {
	  var items = _ref2.items;
	  return _react2.default.createElement(
	    'div',
	    { className: 'row' },
	    (0, _utils.chunk)(items).map(function (group) {
	      return _react2.default.createElement(
	        'div',
	        { key: group, className: 'col' },
	        _react2.default.createElement(ServiceDetailItemsList, { group: group })
	      );
	    })
	  );
	};
	
	var ServiceDetails = function ServiceDetails(_ref3) {
	  var services = _ref3.services;
	  return _react2.default.createElement(
	    'div',
	    null,
	    services.map(function (service) {
	      return _react2.default.createElement(
	        'div',
	        { key: service.text },
	        _react2.default.createElement(
	          'h5',
	          null,
	          _react2.default.createElement('i', { className: 'fa ' + service.icon }),
	          ' ',
	          service.full_text || service.text
	        ),
	        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: service.description } }),
	        service.items && service.items.length && _react2.default.createElement(ServiceDetailItems, { items: service.items }),
	        service.secondary && _react2.default.createElement(
	          'p',
	          { className: 'text-right' },
	          _react2.default.createElement(
	            'small',
	            null,
	            _react2.default.createElement('i', { dangerouslySetInnerHTML: { __html: service.secondary } })
	          )
	        )
	      );
	    })
	  );
	};
	
	exports.default = ServiceDetails;
	module.exports = exports['default'];

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Services = function Services(_ref) {
	  var services = _ref.services;
	  return _react2.default.createElement(
	    "ul",
	    { className: "services list-unstyled" },
	    services.map(function (service) {
	      return _react2.default.createElement(
	        "li",
	        { key: service.text },
	        _react2.default.createElement("i", { className: service.icon, "aria-hidden": "true" }),
	        " ",
	        service.text
	      );
	    })
	  );
	};
	
	exports.default = Services;
	module.exports = exports["default"];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatsTable = function StatsTable(_ref) {
	  var stats = _ref.stats;
	  return _react2.default.createElement(
	    "table",
	    { className: "table table-striped table-hover table-bordered" },
	    _react2.default.createElement(
	      "thead",
	      { className: "thead-inverse" },
	      _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement("th", null),
	        _react2.default.createElement(
	          "th",
	          null,
	          "My Website"
	        ),
	        _react2.default.createElement(
	          "th",
	          null,
	          "The Average Website"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "tbody",
	      null,
	      stats.map(function (stat) {
	        return _react2.default.createElement(
	          "tr",
	          { key: stat.label },
	          _react2.default.createElement(
	            "th",
	            { width: "40%", scope: "row" },
	            stat.label
	          ),
	          _react2.default.createElement(
	            "td",
	            { width: "22%", className: "text-success" },
	            stat.mine
	          ),
	          _react2.default.createElement(
	            "td",
	            { width: "38%", className: "text-danger" },
	            stat.theirs
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = StatsTable;
	module.exports = exports["default"];

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var chunk = function chunk(list) {
	  var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
	  var balanced = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (columns < 2) {
	    return [list];
	  }
	
	  var len = list.length;
	  var out = [];
	  var i = 0;
	  var size = void 0;
	
	  if (len % columns === 0) {
	    size = Math.floor(len / columns);
	    while (i < len) {
	      out.push(list.slice(i, i += size));
	    }
	  } else if (balanced) {
	    while (i < len) {
	      size = Math.ceil((len - i) / columns--);
	      out.push(list.slice(i, i += size));
	    }
	  } else {
	    columns--;
	    size = Math.floor(len / columns);
	    if (len % size === 0) {
	      size--;
	    }
	
	    while (i < size * columns) {
	      out.push(list.slice(i, i += size));
	    }
	
	    out.push(list.slice(size * columns));
	  }
	
	  return out;
	};
	
	exports.chunk = chunk;

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.HomePageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Content = __webpack_require__(26);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Logo = __webpack_require__(27);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Services = __webpack_require__(78);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _ServiceDetails = __webpack_require__(198);
	
	var _ServiceDetails2 = _interopRequireDefault(_ServiceDetails);
	
	var _AboutDetails = __webpack_require__(192);
	
	var _AboutDetails2 = _interopRequireDefault(_AboutDetails);
	
	var _Projects = __webpack_require__(197);
	
	var _Projects2 = _interopRequireDefault(_Projects);
	
	var _ParagraphSection = __webpack_require__(195);
	
	var _ParagraphSection2 = _interopRequireDefault(_ParagraphSection);
	
	var _ScrollComponent2 = __webpack_require__(77);
	
	var _ScrollComponent3 = _interopRequireDefault(_ScrollComponent2);
	
	var _StatsTable = __webpack_require__(199);
	
	var _StatsTable2 = _interopRequireDefault(_StatsTable);
	
	var _reactVerticalTimelineComponent = __webpack_require__(457);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import 'react-vertical-timeline-component/style.min.css';
	
	var Icon = function Icon(_ref) {
	  var type = _ref.type;
	  return _react2.default.createElement('i', { className: type || 'fa fa-briefcase', 'aria-hidden': 'true' });
	};
	
	var headerFadeOffset = 0.03;
	var featuredProjectsLimit = 3;
	
	var HomePageTemplate = exports.HomePageTemplate = function (_ScrollComponent) {
	  _inherits(HomePageTemplate, _ScrollComponent);
	
	  function HomePageTemplate() {
	    _classCallCheck(this, HomePageTemplate);
	
	    var _this = _possibleConstructorReturn(this, _ScrollComponent.call(this));
	
	    _this.state = { headerOpacity: 1, canPerfWar: false };
	    return _this;
	  }
	
	  HomePageTemplate.prototype.onScroll = function onScroll(event, top) {
	    if (!this.el) {
	      return;
	    }
	
	    var opacity = 1 - top / this.el.clientHeight;
	
	    if (opacity >= 0 && opacity <= 1) {
	      if (opacity < 1) {
	        opacity = opacity - headerFadeOffset;
	      }
	
	      this.setState({ headerOpacity: opacity });
	    }
	  };
	
	  HomePageTemplate.prototype.onPerfKeyPress = function onPerfKeyPress(event) {
	    if (event.key == 'Enter') {
	      this.doWar();
	    }
	  };
	
	  HomePageTemplate.prototype.onPerfTextChange = function onPerfTextChange(event) {
	    var canPerfWar = Boolean(event && event.target && event.target.value);
	    var perfWarUrl = canPerfWar ? event.target.value : null;
	
	    this.setState({ canPerfWar: canPerfWar, perfWarUrl: perfWarUrl });
	  };
	
	  HomePageTemplate.prototype.doWar = function doWar() {
	    if (this.state.perfWarUrl) {
	      (0, _gatsbyLink.navigateTo)('/performance?fight=' + this.state.perfWarUrl);
	    }
	  };
	
	  HomePageTemplate.prototype.render = function render() {
	    var _this2 = this;
	
	    var props = this.props;
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'section home-page' },
	      _react2.default.createElement(
	        'header',
	        { className: 'home', style: { backgroundImage: 'url(' + props.image + ')', opacity: this.state.headerOpacity }, ref: function ref(node) {
	            return _this2.el = node;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'container animate fade-in animate-delay-0x' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-10 col-lg-8 col-xl-6' },
	              _react2.default.createElement(_Logo2.default, { size: 'xl' }),
	              _react2.default.createElement(_Services2.default, { services: props.services }),
	              _react2.default.createElement(
	                'h5',
	                null,
	                props.title
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'main' },
	                props.description
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: 'btn btn-outline-primary btn-lg jumbo-btn', to: '/contact' },
	                _react2.default.createElement('i', { className: 'fa fa-handshake-o', 'aria-hidden': 'true' }),
	                ' ',
	                props.contact.text,
	                _react2.default.createElement(
	                  'i',
	                  { className: 'catchphrase' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    ' let\'s work together to build something great!'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'container text-center home-section' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'header-hero animate animate-delay-1x fade-in' },
	          props.heading
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'home-section container animate animate-delay-2x fade-in' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-3 d-none d-md-block' },
	            _react2.default.createElement('i', { className: 'home-design ' + props.performance.side_icon, 'aria-hidden': 'true' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-9 fadebg-left' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              _react2.default.createElement('i', { className: props.performance.heading_icon, 'aria-hidden': 'true' }),
	              '\xA0',
	              props.performance.heading
	            ),
	            _react2.default.createElement(_ParagraphSection2.default, { paragraphs: props.performance.blurbs }),
	            _react2.default.createElement(
	              'h5',
	              null,
	              props.performance.stats_heading,
	              ':'
	            ),
	            _react2.default.createElement(_StatsTable2.default, { stats: props.performance.stats }),
	            _react2.default.createElement(
	              'h1',
	              null,
	              _react2.default.createElement('i', { className: props.performance.heading2_icon, 'aria-hidden': 'true' }),
	              '\xA0',
	              props.performance.heading2
	            ),
	            _react2.default.createElement(_ParagraphSection2.default, { paragraphs: props.performance.blurbs2 })
	          )
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Still not convinced I can build you a better website?',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement(
	              'small',
	              null,
	              'Compare ',
	              _react2.default.createElement(
	                'u',
	                null,
	                'your'
	              ),
	              ' current site against ',
	              _react2.default.createElement(
	                'u',
	                null,
	                'mine'
	              ),
	              ':'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row justify-content-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-8 col-lg-6 col-sm-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group' },
	                _react2.default.createElement('input', { type: 'text', onChange: this.onPerfTextChange.bind(this), onKeyPress: this.onPerfKeyPress.bind(this), className: 'form-control', placeholder: 'Enter your current site URL', 'aria-label': 'Current website URL' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'input-group-btn' },
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: this.doWar.bind(this), className: 'btn btn-secondary', type: 'button', disabled: this.state.canPerfWar ? '' : 'disabled' },
	                    _react2.default.createElement('i', { className: 'fa fa-tachometer', 'aria-hidden': 'true' }),
	                    ' Compare'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('hr', null)
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'home-section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row align-items-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-9' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'fancy' },
	                props.servicesHeading
	              ),
	              _react2.default.createElement(_ServiceDetails2.default, { services: props.services })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-right col-md-3 d-none d-md-block' },
	              _react2.default.createElement('i', { className: 'fa fa-laptop home-skills', 'aria-hidden': 'true' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'home-section brick' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-2 d-none d-sm-block' },
	              _react2.default.createElement('i', { className: 'fa fa-user-circle home-about', 'aria-hidden': 'true' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-10 home-fadebg' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'fancy' },
	                props.aboutHeading
	              ),
	              _react2.default.createElement(_AboutDetails2.default, { details: props.about })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'timeline' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container cushy-top' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'text-center' },
	            'Work experience & education'
	          ),
	          _react2.default.createElement(
	            _reactVerticalTimelineComponent.VerticalTimeline,
	            null,
	            props.timeline.map(function (item) {
	              return _react2.default.createElement(
	                _reactVerticalTimelineComponent.VerticalTimelineElement,
	                { key: item.title,
	                  className: 'vertical-timeline-element--work',
	                  date: item.from + ' to ' + (item.to ? item.to : ' present') + ' (' + ((item.to || new Date().getFullYear()) - item.from) + ' years)',
	                  iconStyle: { background: item.color || 'rgb(33, 150, 243)', color: '#fff' },
	                  icon: _react2.default.createElement(Icon, { type: item.icon,
	                    style: { 'border-top': item.color || 'rgb(33, 150, 243)' } }) },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'vertical-timeline-element-title' },
	                  item.title
	                ),
	                _react2.default.createElement(
	                  'h5',
	                  { className: 'vertical-timeline-element-subtitle' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: item.link, target: '_blank', style: { color: item.color } },
	                    item.company
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  item.description
	                )
	              );
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'text-center cushy-bottom' },
	        _react2.default.createElement(
	          'h5',
	          { className: 'resume-heading' },
	          'Checkout my resume for additional details:'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'btn btn-lg btn-info', to: '/resume' },
	          _react2.default.createElement('i', { className: 'fa fa-file-text-o' }),
	          ' View Resume'
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'container text-center' },
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h1',
	          { className: 'fancy cushy-bottom cushy-top' },
	          'Recent Projects:'
	        ),
	        _react2.default.createElement(_Projects2.default, { projects: props.recentProjects, limit: featuredProjectsLimit })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'text-center cushy-top' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/portfolio', className: 'btn btn-lg btn-outline-secondary' },
	          _react2.default.createElement('i', { className: 'fa fa-folder-open-o', 'aria-hidden': 'true' }),
	          ' View ',
	          props.recentProjects.length - featuredProjectsLimit,
	          ' More Projects'
	        )
	      )
	    );
	  };
	
	  return HomePageTemplate;
	}(_ScrollComponent3.default);
	
	exports.default = function (_ref2) {
	  var data = _ref2.data;
	  var frontmatter = data.markdownRemark.frontmatter;
	  var projects = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(HomePageTemplate, {
	    image: frontmatter.image,
	    title: frontmatter.title,
	    heading: frontmatter.heading,
	    description: frontmatter.description,
	    servicesHeading: frontmatter.services_heading,
	    services: frontmatter.services,
	    contact: frontmatter.contact,
	    performance: frontmatter.performance,
	    aboutHeading: frontmatter.about_heading,
	    about: frontmatter.about,
	    timeline: frontmatter.timeline,
	    recentProjects: projects.filter(function (post) {
	      return post.node.frontmatter.templateKey === 'portfolio-post';
	    })
	  });
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-index-js-a1c5ea20ed6cf2294b6e.js